import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Card } from '../../../legacy/hui/src/styled';
import moderationTickIcon from '../../images/moderation-tick-icon.svg';
import moderationSpinnerIcon from '../../images/moderation-spinner-icon.gif';
import moderationEmptyIcon from '../../images/moderation-empty-icon.svg';

const Checklist = styled.ul`
  position: relative;
  padding-left: 5px;
  z-index: 1;
  margin: 0;

  :before {
    content: '';
    position: absolute;
    left: 10px;
    bottom: 10%;
    height: 80%;
    border-left: 2px dotted #c6c6c7;
    z-index: -1;
  }

  img {
    margin-right: 15px;
  }
`;

const ChecklistItem = styled.li`
  margin: 12px 0;
  z-index: 1;
  list-style-type: none;
  display: flex;
  align-items: center;
`;

const ChecklistIcon = styled.img`
  max-height: 12px;
  flex: 0 0 auto;
`;

export class ModerationCard extends React.Component {
  static propTypes = {
    categoryPerson: PropTypes.string,
    startAnimation: PropTypes.bool,
    onAnimationFinished: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      secondsElapsed: 0,
      timer1: 0,
      timer2: 0,
      timer3: 0,
      timer4: 10,
      step1img: moderationSpinnerIcon,
      step2img: moderationEmptyIcon,
      step3img: moderationEmptyIcon,
      step4img: moderationEmptyIcon,
      open: true
    };
  }

  componentDidMount() {
    if (this.props.startAnimation) {
      this.interval = setInterval(() => {
        this.setState({
          secondsElapsed: this.state.secondsElapsed + 1
        });

        if (this.state.secondsElapsed === this.state.timer1) {
          this.setState({ step1img: moderationTickIcon });
          this.setState({ step2img: moderationSpinnerIcon });
        }
        if (this.state.secondsElapsed === this.state.timer2) {
          this.setState({ step2img: moderationTickIcon });
          this.setState({ step3img: moderationSpinnerIcon });
        }
        if (this.state.secondsElapsed == this.state.timer3) {
          this.setState({ step3img: moderationTickIcon });
          this.setState({ step4img: moderationSpinnerIcon });
        }
        if (this.state.secondsElapsed == this.state.timer4) {
          this.setState({ step4img: moderationTickIcon });
        }
        //after all steps are completed, wait 1 seconds then hide card
        if (this.state.secondsElapsed == this.state.timer4 + 1) {
          //this.setState({ open: false }); //todo handle this in parent
          this.props.onAnimationFinished();
          clearInterval(this.interval);
        }
      }, 1000);
    }

    const min = 1;
    const max = 2.5;
    this.setState({
      timer1: Math.floor(Math.random() * (max - min + 1)) + min,
      timer2: Math.floor(Math.random() * (max - min + 1)) + min + 3,
      timer3: Math.floor(Math.random() * (max - min + 1)) + min + 5
    });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { categoryPerson, ...rest } = this.props;

    return (
      <Card snow p="5px 20px" m={0} {...rest}>
        <Checklist>
          <ChecklistItem>
            <ChecklistIcon src={this.state.step1img} />
            Reviewing your job request
          </ChecklistItem>
          <ChecklistItem>
            <ChecklistIcon src={this.state.step2img} />
            Locating nearby tradies
          </ChecklistItem>
          <ChecklistItem>
            <ChecklistIcon src={this.state.step3img} />
            <span>Matching you with verified {categoryPerson}</span>
          </ChecklistItem>
          <ChecklistItem>
            <ChecklistIcon src={this.state.step4img} />
            Preparing notifications
          </ChecklistItem>
        </Checklist>
      </Card>
    );
  }
}
